

import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Button, Input, Typography, Sheet } from '@mui/joy';
import { supabase } from '../../supabaseClient';

const ClientNewPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const type = searchParams.get('type');
    if (token && type === 'recovery') {
      supabase.auth.exchangeCodeForSession(token).catch(() => {
        setError('Token is invalid or expired.');
      });
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setError(error.message);
    } else {
      setSubmitted(true);
      setTimeout(() => navigate('/client-login'), 2000);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        minHeight: '100vh',
        bgcolor: 'background.body',
        px: 2,
        textAlign: 'center',
      }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 400,
          width: '100%',
          p: 4,
          borderRadius: 'md',
          boxShadow: 'md',
          mx: 'auto',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <img
            src="/fldp_final_color.png"
            alt="FLDP Logo"
            style={{ maxWidth: '160px', marginBottom: '1rem', display: 'block', marginInline: 'auto' }}
          />
          <Typography level="h4">FLDP Client Portal</Typography>
        </Box>

        {submitted ? (
          <Typography>Success! Redirecting to login...</Typography>
        ) : (
          <>
            <Input
              type="password"
              placeholder="New password"
              fullWidth
              sx={{ mb: 2 }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Typography color="danger" level="body-sm" sx={{ mb: 1 }}>
                {error}
              </Typography>
            )}
            <Button fullWidth onClick={handleSubmit}>
              Set Password
            </Button>
          </>
        )}
      </Sheet>
    </Box>
  );
};

export default ClientNewPassword;